import React from 'react';
import { ArrowRight, Download, Infinity, FileText } from 'lucide-react';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-16 px-4 overflow-hidden" data-id="element-82">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-[#d4a853]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-83" />

      <div className="max-w-5xl mx-auto flex flex-col items-center relative z-10" data-id="element-84">
        {/* Accent Badge */}
        <div className="inline-block px-4 py-1.5 rounded-full bg-[#d4a853]/10 border border-[#d4a853]/20 mb-6" data-id="element-85">
          <span className="text-[#d4a853] font-semibold text-sm tracking-wide" data-id="element-86">
            Nadie te preparó para entender tu mundo emocional…
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight text-white text-center mb-6" data-id="element-87">
          Entendé tu apego. <br data-id="element-88" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a853] to-[#fce3b4]" data-id="element-89">
            Recuperá estabilidad.
          </span>{' '}
          <br data-id="element-90" />
          Elegí mejor.
        </h1>

        {/* Subtext */}
        <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl text-center mb-8" data-id="element-91">
          Comprendé por qué te enganchás de más, te cuesta soltar y repetís
          patrones. Este libro te da las herramientas para cambiar tu realidad
          afectiva.
        </p>

        {/* Book Image - Much Larger and Centered */}
        <div className="relative w-full max-w-lg mb-10" data-id="element-92">
          <div className="absolute inset-0 bg-[#d4a853] blur-3xl opacity-25 animate-pulse scale-90" data-id="element-93"></div>
          <img src="https://cdn.magicpatterns.com/uploads/1sUAJC4SxGmBDYRPVxvw9N/ChatGPT_Image_4_feb_2026,_14_36_30.png" alt="Psicología del Apego Moderno Libro" className="relative w-full h-auto object-contain drop-shadow-2xl z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-94" />
        </div>

        {/* CTAs - Below the image */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-95">
          <button onClick={scrollToCheckout} className="px-10 py-4 bg-[#d4a853] hover:bg-[#b88e3e] text-black font-bold text-lg rounded-xl transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(212,168,83,0.4)] flex items-center justify-center gap-2" data-id="element-96">
            Quiero empezar hoy
            <ArrowRight className="w-5 h-5" data-id="element-97" />
          </button>

          <button onClick={scrollToCheckout} className="px-10 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium text-lg rounded-xl transition-all flex items-center justify-center" data-id="element-98">
            Ver combos y precios
          </button>
        </div>

        {/* Microbadges */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-99">
          <div className="flex items-center gap-2" data-id="element-100">
            <Download className="w-4 h-4 text-[#d4a853]" data-id="element-101" />
            <span data-id="element-102">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-103">
            <Infinity className="w-4 h-4 text-[#d4a853]" data-id="element-104" />
            <span data-id="element-105">Acceso de por vida</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-106">
            <FileText className="w-4 h-4 text-[#d4a853]" data-id="element-107" />
            <span data-id="element-108">PDF premium</span>
          </div>
        </div>
      </div>
    </section>;
}